// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"bba36242","606":"94057e0d"}[chunkId] + ".chunk.css";
};